import { useMemo } from 'react';

import {
  type RestrictableAccount,
  useShipmentPastDueRestriction,
} from '@/hooks/useShipmentPastDueRestriction';
import { useStringMap } from '@/hooks/useStringMap';
import { ShipmentStatus } from '@/pages/shipping/utils/enums';

export type ShipmentStatusOption = {
  label: string;
  value: number;
  disabled?: boolean;
};

export function useShipmentStatusOptions(owner?: RestrictableAccount | null): {
  options: ShipmentStatusOption[];
} {
  const shipmentStatus = useStringMap('shipment_status');
  const { isOwnerRestricted } = useShipmentPastDueRestriction();

  const isPastDueRestricted = isOwnerRestricted(owner);
  const options =
    shipmentStatus.type === 'success' ? shipmentStatus.options : undefined;

  return useMemo(() => {
    if (!options) {
      return { options: [] };
    }

    if (!isPastDueRestricted) {
      return { options };
    }

    return {
      options: options.map((option) =>
        option.value === ShipmentStatus.IN_PROGRESS
          ? { ...option, disabled: true }
          : option,
      ),
    };
  }, [isPastDueRestricted, options]);
}
